export enum USER_STATUS {
  ACTIVATION_PENDING = 0, // needs email confirmation
  ACTIVE = 1, // active user
  INACTIVE = 2, // disabled user
}

export enum TOKENS {
  USER_COMPANY_INVITE_TOKEN_EXPIRATION = 7 * 24, // 1 week to wait activations from company invitation
}
